module.exports = __webpack_public_path__ + "img/banano-logo-big.341d2458.png";